(function () {
  function initPillsRegionFilter() {
    var regionLabels = document.querySelectorAll('fieldset.region.dropdown label');
    if (!regionLabels.length) return;

    var sizeFieldset = document.querySelector('fieldset.size.dropdown');
    var _firstLoad = true;

    // ── Persistent caches (built once, reused across region switches) ──
    var _labelMap = null;
    var _variantsCache = null;
    var _regionDataCache = null; // Map<inputId, { regions: string[], oversellRegions: string[], hasDataRegions: bool }>

    function getLabelMap() {
      if (_labelMap) return _labelMap;
      _labelMap = {};
      var labels = document.querySelectorAll('fieldset.size.dropdown label[for]');
      for (var i = 0; i < labels.length; i++) {
        _labelMap[labels[i].htmlFor] = labels[i];
      }
      return _labelMap;
    }

    function getLabel(inputId) { return getLabelMap()[inputId] || null; }

    function getVariantsCached() {
      if (_variantsCache) return _variantsCache;
      var container = sizeFieldset ? (sizeFieldset.closest('variant-radios') || document) : document;
      var scripts = container.querySelectorAll('script[type="application/json"]');
      for (var i = 0; i < scripts.length; i++) {
        try {
          var data = JSON.parse(scripts[i].textContent);
          if (Array.isArray(data) && data.length && data[0] && data[0].id) {
            _variantsCache = data;
            return data;
          }
        } catch (e) { }
      }
      return null;
    }

    // Pre-parse data-regions and data-oversell-regions for each size input.
    // Called once; the DOM attributes don't change between switches.
    function getRegionData(input) {
      if (!_regionDataCache) _regionDataCache = {};
      if (_regionDataCache[input.id]) return _regionDataCache[input.id];

      var raw = input.dataset.regions || '';
      var regions = raw ? raw.split(',').map(function (r) { return r.trim(); }).filter(Boolean) : [];
      var rawO = input.dataset.oversellRegions || '';
      var oversellRegions = rawO ? rawO.split(',').map(function (r) { return r.trim(); }).filter(Boolean) : [];

      var entry = {
        regions: regions,
        oversellRegions: oversellRegions,
        hasDataRegions: input.hasAttribute('data-regions')
      };
      _regionDataCache[input.id] = entry;
      return entry;
    }

    function toggleNoSizesMessage(show) {
      if (!sizeFieldset) return;
      var msg = sizeFieldset.querySelector('.pills-no-sizes-message');
      if (show) {
        sizeFieldset.classList.add('pills-all-unavailable');
        if (!msg) {
          msg = document.createElement('p');
          msg.className = 'pills-no-sizes-message';
          msg.textContent = sizeFieldset.dataset.noSizesMessage || 'All sizes are currently out of stock for this region';
          sizeFieldset.appendChild(msg);
        } else {
          msg.style.display = '';
        }
      } else {
        sizeFieldset.classList.remove('pills-all-unavailable');
        if (msg) msg.style.display = 'none';
      }
    }

    function findFirstSelectable(inputs) {
      for (var i = 0; i < inputs.length; i++) {
        var label = getLabel(inputs[i].id);
        var unavailable = label && label.classList.contains('unavailable');
        if (!unavailable || inputs[i].dataset.oversell === 'true') return inputs[i];
      }
      return inputs[0] || null;
    }

    function isAllUnavailable(inputs) {
      return inputs.length === 0 || inputs.every(function (inp) {
        var label = getLabel(inp.id);
        return label && label.classList.contains('unavailable') && inp.dataset.oversell !== 'true';
      });
    }

    // Called synchronously in the click handler — BEFORE the region radio fires
    // its change event and the theme's variant-radios reads the current selections.
    function preselectBestSizeForRegion(regionValue) {
      if (!sizeFieldset) return;
      var variants = getVariantsCached();
      var regionLower = regionValue.toLowerCase();
      var sizeInputs = sizeFieldset.querySelectorAll('input[type="radio"]');

      for (var i = 0; i < sizeInputs.length; i++) {
        var input = sizeInputs[i];
        var rd = getRegionData(input);
        if (rd.hasDataRegions && (!rd.regions.length || !rd.regions.includes(regionLower))) continue;

        var isOversell = rd.oversellRegions.includes(regionLower);
        var isAvailable = isOversell;
        if (!isAvailable && variants) {
          var sizeValue = input.value;
          isAvailable = variants.some(function (v) {
            if (!v.available && v.inventory_policy !== 'continue') return false;
            var hasRegion = String(v.option1 || '').toLowerCase() === regionLower ||
              String(v.option2 || '').toLowerCase() === regionLower ||
              String(v.option3 || '').toLowerCase() === regionLower;
            var hasSize = v.option1 === sizeValue || v.option2 === sizeValue || v.option3 === sizeValue;
            return hasRegion && hasSize;
          });
        }

        if (isAvailable) {
          input.checked = true;
          return;
        }
      }

      // Fallback — pick any size that belongs to this region.
      for (var j = 0; j < sizeInputs.length; j++) {
        var inp = sizeInputs[j];
        var rd2 = getRegionData(inp);
        if (!rd2.hasDataRegions || (rd2.regions.length > 0 && rd2.regions.includes(regionLower))) {
          inp.checked = true;
          return;
        }
      }
    }

    function filterSizePillsByRegion(region) {
      var isInitialLoad = _firstLoad;
      var regionLower = region.toLowerCase();
      var sizeInputs = document.querySelectorAll('fieldset.size.dropdown input[type="radio"]');
      var visibleInputs = [];
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var FADE_MS = 60;

      function runPA(callback) {
        var paAvailable = typeof ProductAvailability !== 'undefined';
        if (paAvailable) {
          ProductAvailability.update().then(callback);
        } else {
          callback();
        }
      }

      function selectAndDispatch() {
        toggleNoSizesMessage(isAllUnavailable(visibleInputs));
        var toSelect = findFirstSelectable(visibleInputs);
        if (toSelect) {
          if (!toSelect.checked) toSelect.checked = true;
          toSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      function applyRegionState() {
        for (var i = 0; i < sizeInputs.length; i++) {
          var input = sizeInputs[i];
          var rd = getRegionData(input);
          var label = getLabel(input.id);
          var isVisible = !rd.hasDataRegions || (rd.regions.length > 0 && rd.regions.includes(regionLower));

          if (rd.oversellRegions.includes(regionLower)) {
            input.setAttribute('data-oversell', 'true');
          } else {
            input.removeAttribute('data-oversell');
          }

          if (isVisible) {
            input.style.display = '';
            if (label) label.style.display = isInitialLoad ? '' : 'none';
            visibleInputs.push(input);
          } else {
            input.style.display = 'none';
            if (label) label.style.display = 'none';
          }
        }
      }

      function revealNewLabels() {
        if (reducedMotion) {
          for (var i = 0; i < visibleInputs.length; i++) {
            var label = getLabel(visibleInputs[i].id);
            if (label) label.style.display = '';
          }
          if (sizeFieldset) sizeFieldset.style.minHeight = '';
          return;
        }

        // Set up opacity=0 then transition to 1 in a single rAF.
        for (var j = 0; j < visibleInputs.length; j++) {
          var lbl = getLabel(visibleInputs[j].id);
          if (lbl) {
            lbl.style.transition = 'none';
            lbl.style.opacity = '0';
            lbl.style.display = '';
          }
        }

        requestAnimationFrame(function () {
          for (var k = 0; k < visibleInputs.length; k++) {
            var lbl = getLabel(visibleInputs[k].id);
            if (lbl) {
              lbl.style.transition = 'opacity ' + FADE_MS + 'ms ease';
              lbl.style.opacity = '1';
            }
          }
          setTimeout(function () {
            for (var m = 0; m < visibleInputs.length; m++) {
              var lbl = getLabel(visibleInputs[m].id);
              if (lbl) { lbl.style.opacity = ''; lbl.style.transition = ''; }
            }
            if (sizeFieldset) sizeFieldset.style.minHeight = '';
          }, FADE_MS + 10);
        });
      }

      // ── INITIAL LOAD ──
      if (isInitialLoad) {
        applyRegionState();
        // global.js already dispatched the initial change event for PA at ATC enable time.
        toggleNoSizesMessage(isAllUnavailable(visibleInputs));
        _firstLoad = false;
        return;
      }

      // ── USER-TRIGGERED SWITCH ──
      // Hide current labels immediately (they were already hidden in click handler).
      // Apply new state right away, start PA in parallel with reveal animation.
      applyRegionState();

      // Start PA update in parallel — don't wait for it before showing new pills.
      // selectAndDispatch will run after PA finishes to correct disabled states.
      runPA(function () {
        selectAndDispatch();
      });

      // Reveal new labels immediately (don't block on PA).
      revealNewLabels();
    }

    regionLabels.forEach(function (label) {
      label.addEventListener('click', function () {
        var input = this.previousElementSibling;
        if (input && input.value) {
          // Lock fieldset height to prevent layout jump.
          if (sizeFieldset) sizeFieldset.style.minHeight = sizeFieldset.offsetHeight + 'px';

          // Hide current labels instantly using cached map (no querySelectorAll loop).
          var labelMap = getLabelMap();
          var sizeInputs = sizeFieldset ? sizeFieldset.querySelectorAll('input[type="radio"]') : [];
          for (var i = 0; i < sizeInputs.length; i++) {
            if (sizeInputs[i].style.display !== 'none') {
              var lbl = labelMap[sizeInputs[i].id];
              if (lbl && lbl.style.display !== 'none') lbl.style.display = 'none';
            }
          }

          preselectBestSizeForRegion(input.value);
          // Use rAF instead of setTimeout(0) — aligns with browser paint cycle.
          requestAnimationFrame(function () { filterSizePillsByRegion(input.value); });
        }
      });
    });

    // Call directly without setTimeout — no reason to defer on an already-loaded page.
    var checkedRegion = document.querySelector('fieldset.region.dropdown input[type="radio"]:checked');
    if (checkedRegion) {
      filterSizePillsByRegion(checkedRegion.value);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPillsRegionFilter);
  } else {
    initPillsRegionFilter();
  }
})();
